import React, { useState, useEffect } from "react";
import logoFacomLong from "./../../images/LOGOFACOMLONG.png";
import "./Header.css";

const Header = () => {
  return (
    <div
      className="header"
      onClick={() => window.open("https://facom.fr", "_blank")}
    >
      <div className="logo">
        <img src={logoFacomLong} />
      </div>
      <div className="title">
        <div className="headerTitle">Grattez votre TICKET D'OR</div>
        <div className="underTitle">
          et découvrez immédiatement si vous avez gagné !
        </div>
      </div>
    </div>
  );
};

export default Header;
